import WeekSetup from "../Component/WeekSetup";
import { connect } from "react-redux";

import {
  getFieldOfficeStaff,
  updateFieldStaff,
  getServiceAllocationIntialClean,
  getServiceAllocationResidentail,
  getServiceAllocationCommercail,
  getServiceAllocationInstall,
  getWeeklyAllocation,
  resetWeeklyAllocation,
  cancelAndRescheduleWeeklyAllocation,
  getBlockDayList,
  addBlockDayList,
  getWeeklyAvgData,
  getSingleServiceOrder,
  getServiceStatistics,
  rerurnOptimization,
  updateFieldService,
  getFieldServices,
  saveFieldService,
  getFieldOfficeStaffById,
  getServiceReasons,
  getServiceRouteCSVFormat,
  getServiceRoutePDFFormat,
  getServiceList,
  getCustomerServiceList,
  addNewService,
  lockService
} from "../../../../Action";

const mapStateToProps = (state) => {
  let {
    FieldStaff,
    UpdateStaff,
    IntialService,
    ResidentailService,
    InstallService,
    CommercialService,
    WeeklySetup,
    CancelledAllocation,
    BlockDayList,
    AddBlockDay,
    WeeklyAvgData,
    ServiceStatistics,
    SingleService,
    RerunOptimization,
    UpdateFieldServiceAllocation,
    FieldServices,
    SaveFieldService,
    GetStaffFieldById,
    ServiceReasons,
    ServiceRouteCSVFormat,
    ServiceRoutePDFFormat,
    ServiceList,
    CustomerServiceList,
    AddNewService,
    LockService
  } = state;
  return {
    FieldStaff,
    UpdateStaff,
    IntialService,
    ResidentailService,
    CommercialService,
    InstallService,
    WeeklySetup,
    CancelledAllocation,
    BlockDayList,
    AddBlockDay,
    WeeklyAvgData,
    ServiceStatistics,
    SingleService,
    RerunOptimization,
    UpdateFieldServiceAllocation,
    FieldServices,
    SaveFieldService,
    GetStaffFieldById,
    ServiceReasons,
    ServiceRouteCSVFormat,
    ServiceRoutePDFFormat,
    ServiceList,
    CustomerServiceList,
    AddNewService,
    LockService
  };
};
const actionCreators = {
  getFieldOfficeStaff,
  updateFieldStaff,
  getServiceAllocationIntialClean,
  getServiceAllocationResidentail,
  getServiceAllocationCommercail,
  getServiceAllocationInstall,
  getWeeklyAllocation,
  resetWeeklyAllocation,
  cancelAndRescheduleWeeklyAllocation,
  getBlockDayList,
  addBlockDayList,
  getWeeklyAvgData,
  getSingleServiceOrder,
  getServiceStatistics,
  rerurnOptimization,
  updateFieldService,
  getFieldServices,
  saveFieldService,
  getFieldOfficeStaffById,
  getServiceReasons,
  getServiceRouteCSVFormat,
  getServiceRoutePDFFormat,
  getServiceList,
  getCustomerServiceList,
  addNewService,
  lockService
};
export default connect(mapStateToProps, actionCreators)(WeekSetup);
